import { FC } from 'react';
import styles from './Badge.module.scss';

interface Props {
  children: string;
}

export const Badge: FC<Props> = ({ children }) => {
  return <div className={styles.Badge}>{children}</div>;
};
